export default "__VITE_ASSET__BdtMXvIi__"